import currency from 'currency.js';
import * as React from 'react';
import { CurrencyType } from '../../models/utilities/type-models';

// #region Component State

const intiialState = {
    value           : 0,
    maskedValue     : '0.00'
};

type State = Readonly<typeof intiialState>;

// #endregion

// #region Component Props

interface IProps {
    id              : string;
    value           : any;
    onChange        : any;
    currencyType    : CurrencyType;
    showSymbol      : boolean;
    className?      : string;
    disable?        : boolean;
    name?           : string;
}
// #endregion

export class Currency extends React.Component<IProps, State> {

    public static defaultProps = {
        className: '',
        disable: false,
        name: ''
    };

    public state: State = intiialState;

    public componentDidUpdate(prevProps: any) {        
        if (prevProps.value !== this.props.value) {
            this.setInitialValues();
        }
    }

    public componentDidMount() {
        this.setInitialValues();
    }
    
    public UNSAFE_componentWillReceiveProps(newProps : IProps) {

        if (newProps.currencyType !== this.props.currencyType) {
            const e = { 
                target: { 
                    value: this.state.maskedValue
                },
                // tslint:disable-next-line:no-empty
                preventDefault: () => {}
            };
    
            this.onChangeCurrency(e, newProps.currencyType);
        }
    }

    public render() {

        const { id, disable, className, name } = this.props;

        return <input
                id={id}
                aria-label="currency-input"
                className={"form-control " + className }
                type="text"
                name={ name ? name : ''}
                disabled={disable}
                value={this.state.maskedValue ? this.state.maskedValue : ''}
                onChange={this.onChange}
            />;
    }

    public reset = () => {
        const e = { 
            target: { 
                value: '0' 
            },
            // tslint:disable-next-line:no-empty
            preventDefault: () => {}
        };

        this.onChange(e);
    }

    /**
     * Internal change handler for managing masking/unmasking of the value
     * Will call the callback after updating itself
     */
    private onChange = (e: any) => {
        e.preventDefault();

        const val = this.unmaskValue(e.target.value);
        const maskedVal = this.maskValue(val);

        this.setState({
            value: val,
            maskedValue: maskedVal
        });

        return this.props.onChange(e, val, maskedVal);
    }

    /**
     * Internal change handler for changing the currency code
     * Will call the callback after updating itself
     */
    private onChangeCurrency = (e: any, newCurrencyCode : CurrencyType) => {
        e.preventDefault();

        const val = this.unmaskValue(e.target.value);
        const maskedVal = this.maskValue(val, newCurrencyCode);

        this.setState({
            value: val,
            maskedValue: maskedVal
        });

        return this.props.onChange(e, val, maskedVal);
    }

    /**
     * Use currency.js to format the value with currency symbols
     */
    private maskValue = (value: number, newCurrencyCode?: CurrencyType) => {

        let { currencyType } = this.props;

        // If currency id passed in, we assume we're changing the currency type
        if (newCurrencyCode) {
            currencyType = newCurrencyCode;
        }

        // Default to USD
        let config = {
            symbol: "$",
            precision: 2,
            decimal: ".",
            separator: ","
        };

        // Switch on other allowed currency types
        switch (currencyType) {
            case  'CAN':
                config = {
                    symbol: "C$",
                    precision: 2,
                    decimal: ".",
                    separator: ","
                };
        }

        const { showSymbol } = this.props;
        return currency(value, config).format(showSymbol);
    }

    /**
     * String to int translation
     */
    private unmaskValue = (maskedVal: string) => {
        const tmp = maskedVal.replace(/\D/g, '');
        return parseInt(tmp || '0', 10) / 100;
    }

    /**
     * Helper for setting the initial state based on props
     */
    private setInitialValues = () => {
        const { value: givenValue } = this.props;

        const val = givenValue || 0.00;
        const maskedVal = this.maskValue(val);

        this.setState({
            value: val,
            maskedValue: maskedVal
        });
    }

}
